<script>
    import { t } from '../../i18n.js'
    export let options
    export let userSelected = options[0].value
    export let disabled

    const uniqueID = Math.floor(Math.random() * 100)
</script>

<div
    role="radiogroup" 
    class="group-container"
    aria-labelledby={`label-${uniqueID}`}
    id={`group-${uniqueID}`}>
    {#each options as { value, label, name }}
        <input
            type="radio"
            id={name}
            bind:group={userSelected}
            value={value}
            disabled={disabled}
            class="{disabled ? '' : 'cursor-pointer'} sr-only" />
        <label for={name} class="{disabled ? 'opacity-50' : 'cursor-pointer'}">
            {$t(label)}
        </label>
    {/each}
</div>

<style>
    .sr-only {
        position: absolute;
        clip: rect(1px, 1px, 1px, 1px);
        padding: 0;
        border: 0;
        height: 1px;
        width: 1px;
        overflow: hidden;
    }

    input[type="radio"] {
        position: absolute;
    }

    input[type="radio"] + label {
        display: block;
        position: relative;
        text-align: left;
        margin-bottom: 0.5rem;
    }

    input[type="radio"] + label::before {
        content: "";
        position: relative;
        display: inline-block;
        margin-right: 0.5rem;
        width: 1.25rem;
        height: 1.25rem;
        background: transparent;
        border: 1px solid theme('colors.navy');
        border-radius: 50%;
        top: 0.2rem;
    }

    input[type="radio"]:checked + label::before {
        border: 1px solid theme('colors.navy');
        border-radius: 50%;
    }

    input[type="radio"] + label::after {
        content: "";
        position: absolute;
        display: inline-block;
        width: .75rem;
        height: .75rem;
        top: 0.45rem;
        left: 0.25rem;
        background: theme('colors.navy');
        border: 1px solid theme('colors.navy');
        border-radius: 50%;
        transform: scale(0);
    }

    input[type="radio"]:checked + label::after {
        opacity: 1;
        transform: scale(1);
    }
</style>